import { ReactComponent as Logo } from "./svg/mpi.svg"
import { ReactComponent as LogoAllWhiteNew } from "./svg/mpi-steelprocess-all-white-new.svg"
import { ReactComponent as SbText1 } from "./svg/simboluri-text/sb-txt-1.svg"
import { ReactComponent as SbText2 } from "./svg/simboluri-text/sb-txt-2.svg"
import { ReactComponent as SbText3 } from "./svg/simboluri-text/sb-txt-3.svg"

import { ReactComponent as SbPiese1 } from "./svg/sb-piese/confectii-metalice-4.svg"
import { ReactComponent as SbPiese2 } from "./svg/sb-piese/flanse-3.svg"
import { ReactComponent as SbPiese3 } from "./svg/sb-piese/repere-debitate-2.svg"

import { ReactComponent as ArrowLeft } from "./svg/carrousel-arrow-left-1.svg"
import { ReactComponent as ArrowRight } from "./svg/carrousel-arrow-right-1.svg"
import { ReactComponent as Menu } from "./svg/menu.svg"
import { ReactComponent as SubArrowRight } from "./svg/outline-subdirectory_arrow_right-24px.svg"
import { ReactComponent as Settings } from "./svg/settings.svg"

const icons = {
    Logo,
    LogoAllWhiteNew,

    SbText1,
    SbText2,
    SbText3,
    SbPiese1,
    SbPiese2,
    SbPiese3,

    ArrowLeft,
    ArrowRight,
    Menu,
    SubArrowRight,

    Settings,
}
export default icons
